import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone'
})

export class PhonePipe implements PipeTransform {
    transform(val, args) {
        if (val != null && val != undefined) {
            let newVal = '';
            let oldVal = val.toString();
            newVal = "(" + oldVal.substr(0, 3) + ") " + oldVal.substr(3, 3) + "-" + oldVal.substr(6, 4);
            return newVal;
        }
        else {
            return '';
        }
        //return val;
    }
}